{
  "achievements": "Başarılar",
  "advanced": "İleri Seviye",
  "all": "Tümü",
  "antiFakeProtection": "Sahtecilik Önleme Koruması",
  "antiFakeProtectionText": "Sahte etkinliği önlemek için tüm talepler sunucu tarafında doğrulanır.",
  "approvedClaims": "Onaylanan Talepler",
  "approvedExalt": "Onaylanan EXALT",
  "beginner": "Başlangıç",
  "claim5Exalt": "5 EXALT Talep Et",
  "claimDailyMining": "Günlük Madencilik Ödülünü Talep Et",
  "claimDailyRewardDesc": "Günlük 5 EXALT ödülünüzü talep edin.",
  "claimDailyRewardDescription": "Her gün 5 EXALT talep edin.",
  "claimFailed": "Talep başarısız oldu.",
  "claimedToday": "Bugün Talep Edildi",
  "completed": "Tamamlandı",
  "completedTasks": "Tamamlanan Görevler",
  "cooldown": "Bekleme Süresi",
  "correctAnswerRewardAdded": "Doğru cevap! Ödül eklendi.",
  "cryptoBasics": "Kripto Temelleri",
  "dailyMiningRate": "Günlük Madencilik Oranı",
  "dailyReward": "Günlük Ödül",
  "dailyRewardClaimed": "Günlük ödül talep edildi.",
  "dailyStreak": "Günlük Seri",
  "days": "Gün",
  "distributed": "Dağıtılan",
  "downloadCertificate": "Sertifikayı İndir",
  "duration": "Süre",
  "exaltExchangeUser": "Exalt Exchange Kullanıcısı",
  "exaltMiningPool": "EXALT Madencilik Havuzu",
  "failedLoadRewards": "Ödüller yüklenemedi.",
  "firstLesson": "İlk Ders",
  "intermediate": "Orta Seviye",
  "learnEarn": "Öğren ve Kazan",
  "learnEarnSubtitle": "Dersleri izleyin, quizleri tamamlayın ve EXALT ödülleri kazanın.",
  "learnEarnTitle": "Öğren ve Kazan",
  "learnerAchievement": "Öğrenci Başarısı",
  "learningLevel": "Öğrenme Seviyesi",
  "learningProgress": "Öğrenme İlerlemesi",
  "lessonCompleted": "Ders başarıyla tamamlandı.",
  "level": "Seviye",
  "loadingLessons": "Dersler yükleniyor...",
  "locked": "Kilitli",
  "masterAchievement": "Usta Başarısı",
  "miningProtectionNote": "Madencilik ödülleri otomatik ve mükerrer taleplere karşı korunmaktadır.",
  "miningRewardSubmitted": "Madencilik ödül talebi gönderildi.",
  "myRewardClaims": "Ödül Taleplerim",
  "noAchievements": "Henüz başarı yok.",
  "noActivityYet": "Henüz etkinlik yok.",
  "noMinersYet": "Henüz madenci yok.",
  "noReferrersYet": "Henüz yönlendiren yok.",
  "noRewardClaimsYet": "Henüz ödül talebi yok.",
  "oneClaimEvery24Hours": "Her 24 saatte bir talep hakkı verilir.",
  "optionAfterPayment": "Ödeme onaylandıktan sonra",
  "optionAnyTime": "Herhangi bir zamanda",
  "optionBeforePayment": "Ödemeden önce",
  "optionDeleteTokens": "Tokenleri sil",
  "optionLockTokens": "Ödül için tokenleri kilitle",
  "optionPrivateKey": "Özel anahtarı paylaş",
  "optionProtectWallet": "Cüzdan anahtarlarını koru",
  "optionSendTokens": "Tokenleri gönder",
  "optionUnknownLinks": "Bilinmeyen bağlantıları kullan",
  "p2pSafety": "P2P Güvenliği",
  "pendingValue": "Bekleyen Değer",
  "questionCrypto": "Kriptoda en güvenli kural nedir?",
  "questionP2p": "P2P'de kriptoyu ne zaman serbest bırakmalısınız?",
  "questionStaking": "Staking ne anlama gelir?",
  "quiz": "Quiz",
  "recentActivity": "Son Etkinlik",
  "referralRewardNote": "Referans ödülleri yönetici doğrulamasından sonra yatırılır.",
  "referralRewardPool": "Referans Ödül Havuzu",
  "referrals": "Referanslar",
  "reward": "Ödül",
  "rewardClaim": "Ödül Talebi",
  "rewardClaimFailed": "Ödül talebi başarısız oldu.",
  "rewardClaimed": "Ödül başarıyla talep edildi.",
  "rewardCompleted": "Ödül tamamlandı.",
  "rewardFailed": "Ödül talebi başarısız oldu.",
  "searchLessons": "Ders ara...",
  "securityReview": "Güvenlik İncelemesi",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "stakingGuide": "Staking Rehberi",
  "startLesson": "Derse Başla",
  "submitQuizClaimReward": "Quizi Gönder ve Ödülü Talep Et",
  "submitting": "Gönderiliyor...",
  "todayClaims": "Bugünkü Talepler",
  "topLearners": "En İyi Öğrenciler",
  "topMiners": "En İyi Madenciler",
  "topReferrers": "En İyi Yönlendirenler",
  "totalClaims": "Toplam Talepler",
  "totalPool": "Toplam Havuz",
  "totalRewards": "Toplam Ödüller",
  "used": "Kullanıldı",
  "videoCryptoBasics": "Kripto nedir ve borsalar nasıl çalışır?",
  "videoP2pSafety": "P2P kullanıcılarıyla güvenli işlem nasıl yapılır",
  "videoStakingGuide": "Staking ödülleri nasıl çalışır",
  "viewAgain": "Tekrar İzle",
  "wrongAnswerTryAgain": "Yanlış cevap. Lütfen tekrar deneyin.",
  "xpPoints": "XP Puanları",
  "you": "Siz"
}